package com.kinoshazam.history

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

/**
 * The main-screen tab (home, movies, series, cartoons, favorites).
 * The navigation route stays [com.kinoshazam.model.Route.Main]; only the web address
 * and this flow change when the user switches tabs.
 */
object WebMainTab {
    private val selected = MutableStateFlow(TAB_HOME)
    val current: StateFlow<String> = selected

    private var onRestore: ((String) -> Unit)? = null

    private var replaceTabChange = false

    /**
     * @param replace when the app corrects the tab on its own (an empty favorites list
     * leaves that tab). The history entry is rewritten so Back does not reopen it.
     */
    fun report(tab: String, replace: Boolean = false) {
        val normalized = tab.ifBlank { TAB_HOME }
        if (replace) replaceTabChange = true
        if (selected.value != normalized) selected.value = normalized
        else if (replace) replaceTabChange = false
    }

    fun consumeReplace(): Boolean {
        val value = replaceTabChange
        replaceTabChange = false
        return value
    }

    fun apply(tab: String) {
        val normalized = tab.ifBlank { TAB_HOME }
        selected.value = normalized
        onRestore?.invoke(normalized)
    }

    fun bind(handler: (String) -> Unit) {
        onRestore = handler
        handler(selected.value)
    }

    fun unbind() {
        onRestore = null
    }
}
